import React from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import uiConfig from '../../data/uiConfig';

type CheckboxProps = {
  id?: string;
  label: string;
  labelColor?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  color?: string;
  isDarkColor?: boolean;
};

export const Checkbox = ({
  id,
  label,
  labelColor,
  checked,
  onChange,
  disabled = false,
  color = uiConfig.input.checkbox,
  isDarkColor = false
}: CheckboxProps) => {

  const inputId = React.useId();
  const hover = uiConfig.input.selectionGroupHover

  return (
    <label
      htmlFor={id ?? inputId}
      className={`flex items-center gap-3 px-2 py-1 rounded-md cursor-pointer transition
        ${disabled ? "opacity-50 cursor-not-allowed" : hover}`}
    >
      <span className="relative w-5 h-5 flex items-center justify-center">
        <input
          id={id ?? inputId}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          className="peer absolute w-full h-full opacity-0 cursor-pointer"
        />
        <span
          className={`w-5 h-5 rounded border-2 flex items-center justify-center transition
            ${checked ? color : "border-gray-400 bg-transparent"}`}
        >
          {checked && (
            <CheckIcon className={`w-4 h-4 ${isDarkColor ? "text-white" : "text-gray-800"}`} />
          )}
        </span>
      </span>
      <span className={`text-sm ${labelColor}`}>{label}</span>
    </label>
  )
};
